export default __webpack_public_path__ + "static/media/bio.63af50c6.png";